import { render, staticRenderFns } from "./Reward.vue?vue&type=template&id=8d4970f6&scoped=true"
import script from "./Reward.vue?vue&type=script&lang=js"
export * from "./Reward.vue?vue&type=script&lang=js"
import style0 from "./Reward.vue?vue&type=style&index=0&id=8d4970f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4970f6",
  null
  
)

export default component.exports